export const appendAnalyticsParamsToURL = (url: string): string => {
  const urlObject = new URL(url);
  // UTM stands for Urchin Tracking Module and is used for analytics tracking,
  // see https://en.wikipedia.org/wiki/UTM_parameters
  urlObject.searchParams.append('utm_source', 'forethought-chat');
  urlObject.searchParams.append('utm_lp', 'forethought-chat');
  return urlObject.href;
};
